import VeeValidate, {Validator} from 'vee-validate';
import Vue, { PluginFunction } from 'vue';
import moment from 'moment';
//import { L } from '@/asdcom/BaseComponent';
// import {loadLocaleData} from "@/vee-validate";

export default class Validation {

    public static init(messages:any):void {

        Validator.extend("requireAtLeastOneCheckbox", {
            getMessage: (errMsg:string):string => {
                return errMsg;
            },
            validate: (value:boolean, params:any):boolean => {
                let ret = value === true;
                for (let i = 0; i < params.length; i++) {
                    ret = ret || params[i] === true;
                }
                return ret;
            }
        });

      
        
        Validator.extend('dateInFuture', {
            getMessage: (field:any):string => messages.dateInFuture.replace('{fieldName}', field),
            validate: (value:any):boolean => { 
                return !moment(value).isAfter(moment(), 'day');
            }
        });

        Validator.extend('dateAfter', {
            getMessage: (field:any):string => 
                messages.after.replace('{fieldName}', field).replace('{0}', 'From Date'),
            validate: (value:any, date:any):boolean => {
                return moment(value).isAfter(moment(date[0].date), 'day');
            }
        });

        Validator.extend('mustBeSelected', {
            getMessage: (field:any):string => messages.mustBeSelected.replace('{fieldName}', field),
            validate: (value:any):boolean => {
                console.error("mustBeSelected")
                return value !== 0;
            }
        });
        Validator.extend('notInList', {
            getMessage: (field:any,args:any):string => args[0].message || messages.alreadyTaken.replace('{fieldName}', field),
            validate: (value:any, args:any):boolean => {
                return typeof value ==='string' && value.trim().length > 0 && args[0].list ? args[0].list.indexOf(value) ===-1 : true;
            }
        });

        Vue.use(VeeValidate as any, this.config as any);
        this.loadLocaleData(messages);
    }

    public static loadLocaleData(data: any){
        if(data){
            const defaultLocale = 'en';
            const validationDictionary:any = {};

            validationDictionary[defaultLocale] = {
                // attributes: data,
                messages: {
                    after: function (n:any, e:any):string {
                        return data['after'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "В поле " + n + " должна быть дата после " + e[0] + ".";
                    }, alpha_dash: function (n:any):string {
                        return data['alpha_dash'].replace('{fieldName}', n);
                        // return "Поле " + n + " может содержать только буквы, цифры и дефис."
                    }, alpha_num: function (n:any):string {
                        return data['alpha_num'].replace('{fieldName}', n);
                        // return "Поле " + n + " может содержать только буквы и цифры."
                    }, alpha_spaces: function (n:any):string {
                        return data['alpha_spaces'].replace('{fieldName}', n);
                        // return "Поле " + n + " может содержать только буквы и пробелы."
                    }, alpha: function (n:any):string {
                        return data['alpha'].replace('{fieldName}', n);
                        // return "Поле " + n + " может содержать только буквы."
                    }, before: function (n:any, e:any):string {
                        return data['before'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "В поле " + n + " должна быть дата до " + e[0] + "."
                    }, between: function (n:any, e:any):string {
                        return data['between'].replace('{fieldName}', n).replace('{0}', e[0]).replace('{1}', e[1])
                        // return "Поле " + n + " должно быть между " + e[0] + " и " + e[1] + "."
                    }, confirmed: function (n:any, e:any):string {
                        return data['confirmed'].replace('{fieldName}', n);
                        // return "Поле " + n + " не совпадает с " + e[0] + "."
                    }, credit_card: function (n:any):string {
                        return data['credit_card'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть действительным номером карты"
                    }, date_between: function (n:any, e:any):string {
                        return data['date_between'].replace('{fieldName}', n).replace('{0}', e[0]).replace('{1}', e[1])
                        // return "Поле " + n + " должно быть между " + e[0] + " и " + e[1] + "."
                    }, date_format: function (n:any, e:any):string {
                        return data['date_format'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "Поле " + n + " должно быть в формате " + e[0] + "."
                    }, decimal: function (n:any, e:any):string {
                        void 0 === e && (e = []);
                        let t = e[0];
                        return void 0 === t && (t = "*"), data['decimal'].replace('{fieldName}', n).replace('{0}', ("*" === t ? "" : t))
                        // return void 0 === t && (t = "*"), "Поле " + n + " должно быть числовым и может содержать " + ("*" === t ? "" : t) + " десятичных числа."
                    }, digits: function (n:any, e:any):string {
                        return data['digits'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "Поле " + n + " должно быть числовым и точно содержать " + e[0] + " цифры."
                    }, dimensions: function (n:any, e:any):string {
                        return data['dimensions'].replace('{fieldName}', n).replace('{0}', e[0]).replace('{1}', e[1])
                        // return "Поле " + n + " должно быть " + e[0] + " пикселей на " + e[1] + " пикселей."
                    }, email: function (n:any):string {
                        return data['email'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть действительным электронным адресом."
                    }, ext: function (n:any, e:any):string {
                        return data['ext'].replace('{fieldName}', n).replace('{0}', e.slice(0))
                        // return "Поле " + n + " должно быть действительным файлом. (" + e.slice(0) + ")"
                    }, image: function (n:any):string {
                        return data['image'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть изображением."
                    }, in: function (n:any):string {
                        return data['in'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть допустимым значением."
                    }, ip: function (n:any):string {
                        return data['ip'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть действительным IP-адресом."
                    }, max: function (n:any, e:any):string {
                        return data['max'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "Поле " + n + " не может быть более " + e[0] + " символов."
                    }, max_value: function (n:any, e:any):string {
                        return data['max_value'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "Поле " + n + " должно быть " + e[0] + " или менее."
                    }, mimes: function (n:any, e:any):string {
                        return data['mimes'].replace('{fieldName}', n).replace('{0}', e.slice(0))
                        // return "Поле " + n + " должно иметь действительный тип файла. (" + e.slice(0) + ")"
                    }, min: function (n:any, e:any):string {
                        return data['min'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "Поле " + n + " должно быть не менее " + e[0] + " символов."
                    }, min_value: function (n:any, e:any):string {
                        return data['min_value'].replace('{fieldName}', n).replace('{0}', e[0])
                        // return "Поле " + n + " должно быть " + e[0] + " или больше."
                    }, not_in: function (n:any):string {
                        return data['not_in'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть допустимым значением."
                    }, numeric: function (n:any):string {
                        return data['numeric'].replace('{fieldName}', n);
                        // return "Поле " + n + " должно быть числом."
                    }, regex: function (n:any):string {
                        return data['regex'].replace('{fieldName}', n);
                        // return "Поле " + n + " имеет ошибочный формат."
                    }, required: function (n:any):string {
                        return data['required'].replace('{fieldName}', n);
                        // return "Поле " + n + " обязательно для заполнения."
                    }, size: function (n:any, e:any):string {
                        let t, r, u, i = e[0];
                        return data['size'].replace('{fieldName}', n).replace('{0}', e[0] + 'KB');
                        // return data['size'].replace('{fieldName}', n).replace('{0}', (t = i, r = 1024, u = 0 == (t = Number(t) * r) ? 0 : Math.floor(Math.log(t) / Math.log(r)), 1 * (t / Math.pow(r, u)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][u]));
                        // return "Поле " + n + " должно быть меньше, чем " + (t = i, r = 1024, u = 0 == (t = Number(t) * r) ? 0 : Math.floor(Math.log(t) / Math.log(r)), 1 * (t / Math.pow(r, u)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][u]) + "."
                    }, url: function (n:any):string {
                        return data['url'].replace('{fieldName}', n);
                        // return "Поле " + n + " имеет ошибочный формат URL."
                    }
                },
            };

            Validator.localize(validationDictionary);
        }
    };

    private static readonly config = {
        errorBagName: 'v_errors', // change if property conflicts
        fieldsBagName: 'v_fields',
        delay: 0,
        locale: 'en',
        // dictionary: null,
        strict: true,
        classes: false,
        classNames: {
            touched: 'touched', // the control has been blurred
            untouched: 'untouched', // the control hasn't been blurred
            valid: 'valid', // model is valid
            invalid: 'invalid', // model is invalid
            pristine: 'pristine', // control has not been interacted with
            dirty: 'dirty' // control has been interacted with
        },
        events: 'input',
        inject: true,
        validity: false,
        aria: true,
        i18n: null, // the vue-i18n plugin instance,
        i18nRootKey: 'validations' // the nested key under which the validation messsages will be located
    };
}
